/**
 * askEvents — lets a card ask a follow-up question on the user's behalf.
 *
 * Cards render inside the chat thread without access to the page's submit
 * function, so a tappable chip dispatches a window event and Chat.tsx (the
 * one subscriber) submits the question exactly as a typed one.  Used by the
 * definition card's related terms and "more" line (decision 0017 follow-up).
 */
const EVENT = "scoutdex:ask";

/** Ask `question` as if the user had typed it. */
export function askQuestion(question: string): void {
  const q = question.trim();
  if (!q) return;
  window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: q }));
}

/** Subscribe to asked questions; returns the unsubscribe function. */
export function onAskQuestion(handler: (question: string) => void): () => void {
  const listener = (e: Event) => {
    const detail = (e as CustomEvent<string>).detail;
    if (typeof detail === "string" && detail.trim()) handler(detail.trim());
  };
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
